import { gfhAPI } from '../httpClient';

export default {
  getApiKey: (type: string, userId: string) => {
    return gfhAPI.post('/pricing-tool/get', { type, userId });
  },

  createApiKey: (type: string, userId: string) => {
    return gfhAPI.post('/pricing-tool/activate', { type, userId });
  },
};
